import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { PurlReferralDetails } from '../interfaces/purl-referral-resposne.interface';
import { REFERRAL_TYPE_DISPLAY } from '../interfaces/referral-type.enum';
import { BooleanInput } from '@ptl/global-components';

@Component({
    selector: 'app-purl-status-card',
    templateUrl: './purl-status-card.component.html',
    styleUrls: ['./purl-status-card.component.scss'],
    standalone: false
})
export class PurlStatusCardComponent implements OnInit {
  @Input() referral: PurlReferralDetails;
  @Input() @BooleanInput() showAppInProgressStep: boolean;
  @Input() @BooleanInput() showAppReferralType: boolean;
  @Input() @BooleanInput() isPassiveReferralView: boolean;

  progressPercent = 0;
  clickedStarted: string; 
  clickStartClass: string; 

  constructor() { }

  ngOnInit() {
    const currentPlanYear = moment().month() > 5 ? moment().year() + 1 : moment().year()
    this.referral.referralType = this.referral.referralType === ("PRODUCER_URL_"+currentPlanYear) ? REFERRAL_TYPE_DISPLAY["PRODUCER_URL"] : REFERRAL_TYPE_DISPLAY[this.referral.referralType];
    if (environment.initData.brand.ASPID === 'MN') {
      var timeDifference = moment.duration("01:00:00");
      this.referral.emailSent = moment(this.referral.emailSent).subtract(timeDifference).format('MM/DD/YYYY, h:mm a');

      this.referral.clicked.forEach((clickTimeString, index) => {
        const formattedClickTime = moment(clickTimeString).subtract(timeDifference).format('MM/DD/YYYY, h:mm a');
        this.referral.clicked[index] = formattedClickTime;
      });

      this.referral.submittedApps.forEach((app, index) => {
        this.referral.submittedApps[index].timereference = moment(app.timereference).subtract(timeDifference).format('MM/DD/YYYY, h:mm a'); 
      });    
    }

    this.clickedStarted = this.isPassiveReferralView === true ? "App Started" : "Link Clicked"

    this.clickStartClass = this.isPassiveReferralView === true ? 'left-end' : 'middle'

    // Email sent
    if (this.referral.emailSent) {
      this.progressPercent = 25;
    } else {
      this.referral.emailSent = 'N/A';
    }
    // Clicks
    if (this.progressPercent >= 25 && this.referral.clicked && this.referral.clicked.length > 0) {
      this.progressPercent = 50;
    } else {
      this.referral.clicked = [];
      this.referral.clicked.push('N/A');
    }
    if (this.showAppInProgressStep) {
      // In progress apps
      if (this.progressPercent >= 50 && this.referral.inProgressApps && this.referral.inProgressApps.length > 0) {
        this.progressPercent = 75;
      } else {
        this.referral.inProgressApps = [];
        const app = {
          applicationId: 'N/A',
          timereference: '',
          status: ''
        };
        this.referral.inProgressApps.push(app);
      }
    }
    // Submitted apps
    if (this.referral.submittedApps && this.referral.submittedApps.length > 0) {
      this.progressPercent = 100;
    } else {
      this.referral.submittedApps = [];
      const app = {
        applicationId: 'N/A',
        timereference: '',
        status: ''
      };
      this.referral.submittedApps.push(app);
    }
  }



}
